/**
 * Маппер для преобразования путей изображений категорий из API в локальные пути
 * 
 * API возвращает пути вида /static/category-*.png
 * Локальные файлы находятся в public/img/survey/categories/
 */

const categoryImageMap: Record<string, string> = {
  '/static/category-tops.png': '/img/survey/categories/Profile_Size icons.png',
  '/static/category-bottoms.png': '/img/survey/categories/Bottom.png',
  '/static/category-dresses.png': '/img/survey/categories/Dress.png',
  '/static/category-outerwear.png': '/img/survey/categories/Outwear.png',
  '/static/category-lingerie.png': '/img/survey/categories/Swimsuit.png',
  '/static/category-shoes.png': '/img/survey/categories/Foot.png'
}

/**
 * Преобразует путь изображения категории из API в локальный путь
 * @param imagePath - путь изображения из API (например, /static/category-tops.png)
 * @returns локальный путь к изображению или исходный путь, если маппинг не найден
 */
export function mapCategoryImage(imagePath: string): string {
  if (!imagePath) {
    return imagePath
  }
  
  return categoryImageMap[imagePath] || imagePath
}

